import React from "react";
import styled from "styled-components/macro";
import DropdownItem from "./DropdownItem";
import { MenuItem } from "features/header/types";
import { partners } from "components/Partners/mock";
import PartnersItem from "components/Partners/PartnersItem";
import { buttonType } from "components/Button/Button";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import { setPage } from "features/pagination/paginationSlice";
import { useDispatch } from "react-redux";

interface DropdownProps {
  item: MenuItem;
}

const BrandsDropdown: React.FC<DropdownProps> = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const viewAll = () => {
    dispatch(setPage(1));
    navigate(`/category`);
  };
  return (
    <DropdownItem title={item.title}>
      <Wrapper>
        <BrandsGridContainer>
          {partners.map((i, idx) => {
            return <PartnersItem key={idx} item={i} />;
          })}
        </BrandsGridContainer>
        <ButtonContainer>
          <Button
            onClick={viewAll}
            title="Виж всички"
            type={buttonType.blueBtn}
            classNames="order-button"
          />
        </ButtonContainer>
      </Wrapper>
    </DropdownItem>
  );
};

export default BrandsDropdown;
const Wrapper = styled.div`
  max-height: 400px;
  width: 600px;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;
const BrandsGridContainer = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  grid-template-rows: repeat(4, 1fr);
`;
const ButtonContainer = styled.div`
  max-width: 200px;
  padding-top: 20px;
  align-self: flex-end;
`;
